import React from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Autocomplete,
  Box,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { Send } from "lucide-react";
import { RichTextEditor } from "./Editor";

export default function MessageComposer({
  companies,
  lawyers,
  sendMode,
  setSendMode,
  newMsg,
  setNewMsg,
  editorState,
  onEditorChange,
  flagCompanySelected,
  filterDataByCompany,
  insideCase = false,
  filteredOptions = null,
  sendMessage,
}) {
  return (
    <Card elevation={1}>
      <CardContent>
        <Typography variant="h4" mb={2}>
          Nuevo mensaje
        </Typography>

        <Box display="flex" gap={3} mb={2}>
          <FormControlLabel
            control={
              <Switch
                checked={sendMode === "lawyer"}
                onChange={() => setSendMode("lawyer")}
              />
            }
            label="Enviar Abogado"
          />
          {insideCase && (
            <FormControlLabel
              control={
                <Switch
                  checked={sendMode === "client"}
                  onChange={() => setSendMode("client")}
                  color="primary"
                />
              }
              label="Enviar Cliente"
            />
          )}
        </Box>

        {sendMode === "lawyer" && (
          <Autocomplete
            options={companies}
            getOptionLabel={(o) => o?.company_name || ""}
            onChange={(e, v) => filterDataByCompany(v)}
            renderInput={(params) => (
              <TextField {...params} label="Empresa" size="small" />
            )}
          />
        )}

        {/* <Autocomplete
          options={lawyers}
          disabled={!flagCompanySelected}
          getOptionLabel={(o) => `${o.name} ${o.surname}`}
          sx={{ mt: 2 }}
          onChange={(e, v) => setNewMsg((p) => ({ ...p, to: v }))}
          renderInput={(params) => (
            <TextField {...params} label="Destinatario" size="small" />
          )}
        /> */}

        <Autocomplete
          sx={{ mt: "10px" }}
          options={filteredOptions}
          value={
            filteredOptions?.some(
              (o) => o.id === newMsg?.to?.id && o.type === newMsg?.to?.type,
            )
              ? newMsg.to
              : null
          }
          isOptionEqualToValue={(option, value) =>
            option?.id === value?.id && option?.type === value?.type
          }
          getOptionLabel={(option) =>
            option.isCaseLawyer
              ? `${option.name} ${option.surname} (Abogado del caso)`
              : `${option.name} ${option.surname}`
          }
          disabled={!flagCompanySelected}
          onChange={(event, value) =>
            setNewMsg((prev) => ({ ...prev, to: value }))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                sendMode === "client" ? "Enviar a cliente" : "Enviar a abogado"
              }
              size="small"
              sx={{ mb: 2 }}
            />
          )}
        />

        <TextField
          label="Asunto"
          fullWidth
          size="small"
          sx={{ my: 2 }}
          value={newMsg.subject}
          onChange={(e) => setNewMsg({ ...newMsg, subject: e.target.value })}
        />

        <RichTextEditor
          editorState={editorState}
          onEditorChange={onEditorChange}
        />

        <Button
          variant="contained"
          startIcon={<Send />}
          sx={{ mt: 2 }}
          onClick={sendMessage}>
          Enviar
        </Button>
      </CardContent>
    </Card>
  );
}
